import React from 'react'
import { Indicator, Popover } from 'is24-corecss'
import { useTranslation } from 'react-i18next'
import { IconS24InfoCircle24 } from '@is24/cosma-ui-icons'
import styles from './RentPriceCheckLabel.module.css'

export function RentPriceCheckLabel() {
  const { t } = useTranslation()
  const label = t('wizard.screen.basicInfo.price.recommendedNotification.check.label')

  return (
    <Indicator
      appearance='label'
      labelColor='gray'
      labelVariant='flat'
      labelSize='small'
      rightIcon={
        <Popover.Root placement='bottom-start'>
          <Popover.Target as='button' className={styles.infoButton} aria-label={`${label} Info`}>
            <IconS24InfoCircle24 width={16} height={16} />
          </Popover.Target>
          <Popover.Content className={`${styles.popoverContent} font-body-small-regular`}>
            {t('wizard.screen.basicInfo.price.recommendedNotification.check.disclaimer')}
          </Popover.Content>
        </Popover.Root>
      }
    >
      {label}
    </Indicator>
  )
}
